"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var dateTimeRangePickerProps = {
    fromPickerProps: {
        dateProps: {
            className: theme.date,
            small: true,
            format: "DD/MM/YY"
        },
        hourProps: {
            className: theme.hour,
            small: true,
        }
    },
    toPickerProps: {
        dateProps: {
            className: theme.date,
            small: true,
            format: "DD/MM/YY"
        },
        hourProps: {
            className: theme.hour,
            small: true
        }
    }
};
exports.default = (function (props) { return (React.createElement("div", { className: theme.timeframe },
    React.createElement(ui_1.DateTimeRangePicker, tslib_1.__assign({ fromDate: props.fromDate, toDate: props.toDate, onFromChange: props.onFromChange, onToChange: props.onToChange, enableAllDay: false }, dateTimeRangePickerProps)),
    props.withTimezone ? (React.createElement("div", { className: theme.timezone }, props.useExtendedTimezonePicker
        ? React.createElement(ui_1.TimezonePickerExtended, { onChange: props.onTimezoneChange, timezone: props.timezone, disabled: props.isLoading, fill: true, searchable: true })
        : React.createElement(ui_1.TimezonePicker, { onChange: props.onTimezoneChange, timezone: props.timezone, disabled: props.isLoading, fill: true, searchable: true }))) : null,
    props.withPeriod ? (React.createElement("div", { className: theme.period },
        React.createElement(ui_1.PeriodPicker, { period: props.period, onChange: props.onPeriodChange, fill: true }))) : null)); });
